<template>
  <div class="fun">
    <el-button-group>
      <el-button v-if="this.$fun.isQx(this.qx, 'module:add')" type="primary" icon="Plus" @click="addInfo">添加</el-button>
      <el-button v-if="this.$fun.isQx(this.qx, 'module:del')" type="danger" icon="Delete" @click="delInfo">删除</el-button>
      <el-button v-if="this.$fun.isQx(this.qx, 'module:enable')" type="success" icon="CircleCheck" @click="enableInfo(true)">启用</el-button>
      <el-button v-if="this.$fun.isQx(this.qx, 'module:enable')" type="info" icon="CircleClose" @click="enableInfo(false)">禁用</el-button>
    </el-button-group>
    <STC colName="moduleColumn" :colList="colList" />
  </div>
  <el-table v-loading="tableLoading" :data="tableData" highlight-current-row stripe border row-key="id" :expand-row-keys="expandrowkeys"
      :height="tableHeight" style="width: 100%" @current-change="handleCurrentChange"
      header-row-class-name="header-row" header-cell-class-name="header-cell">
    <el-table-column v-if="this.$fun.isExist(checkColList, '序')" type="index" label="序" width="50"></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '功能模块')" prop="name" label="功能模块" width="200"></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '类别')" prop="type" label="类别" width="70"></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '编码')" prop="code" label="编码" width="120"></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '图标')" prop="icon" label="图标" width="60">
      <template #default="scope">
        <component :is="scope.row.icon" class="icon" ></component>
      </template>
    </el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '链接/权限标识')" prop="link" label="链接/权限标识" show-overflow-tooltip></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '描述')" prop="desc" label="描述" show-overflow-tooltip></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '排序')" prop="queue" label="排序" width="60"></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '状态')" label="状态" width="60">
      <template #default="scope">
        <el-icon v-if="scope.row.isEnable" class="check" title="启用"><Check /></el-icon>
        <el-icon v-else class="close" title="禁用"><Close /></el-icon>
      </template>
    </el-table-column>
    <el-table-column width="100">
      <template #header>
        操作
      </template>
      <template #default="scope">
        <el-button v-if="this.$fun.isQx(this.qx, 'module:edit')" text type="primary" @click="editInfo(scope.row.id)">修改</el-button>
      </template>
    </el-table-column>
  </el-table>
  <el-dialog :title="dialogTitle" v-model="dialogFormVisible" :close-on-click-modal="false" :before-close="closeForm">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="130px">
      <input v-model="form.id" type="hidden">
      <el-form-item label="模块名称" prop="name">
          <el-input v-model="form.name" maxlength="50" class="width"></el-input>
      </el-form-item>
      <el-form-item label="上级模块" prop="parentId">
        <!-- <el-tree ref="tree" node-key="id" :data="menuData" :props="defaultProps"
          @node-click="handleNodeClick" highlight-current default-expand-all class="width">
        </el-tree>
        <input v-model="form.parentId" type="hidden"> -->
        <el-tree-select v-model="form.parentId" :data="menuData" placeholder="请选择一个模块"
          highlight-current default-expand-all />
      </el-form-item>
      <el-form-item label="功能类别" prop="type">
        <el-radio-group v-model="form.type" @change="moduleTypeChange">
          <el-radio-button label=1>功能模块</el-radio-button>
          <el-radio-button label=2>功能权限</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.type === 1" label="模块编码" prop="code">
          <el-input v-model="form.code" maxlength="50" class="width"></el-input>
      </el-form-item>
      <el-form-item :label="[form.type === 1 ? '链接地址' : '权限标识']" prop="link">
          <el-input v-model="form.link" maxlength="100" class="width"></el-input>
      </el-form-item>
      <el-form-item v-if="form.type === 1" label="模块图标" prop="icon">
        <el-select v-model="form.icon" filterable clearable placeholder="请选择" class="width">
          <el-option v-for="item in iconData" :key="item.value" :label="item.label" :value="item.value">
            <component :is="item.value" class="icon" ></component>
             <span>{{ item.label }}</span></el-option>
        </el-select>
        <component :is="form.icon" class="icon" ></component>
      </el-form-item>
      <el-form-item label="描 述" prop="desc">
        <el-input v-model="form.desc " type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="排序">
        <el-input-number v-model="form.queue" :min="0" />
      </el-form-item>
    </el-form>
    <template #footer>
    <span class="dialog-footer">
      <el-button @click="closeForm">关 闭</el-button>
      <el-button @click="resetForm">重 填</el-button>
      <el-button type="primary" @click="saveInfo">确 定</el-button>
    </span>
  </template>
    </el-dialog>
</template>

<script>
// 选择显示的表列
import STC from '@/components/SelectTableColumn'
export default {
  name: 'module',
  components: {
    STC
  },
  data () {
    var validateParentId = (rule, value, callback) => {
      // var val = this.form.type
      if (!this.isAdd && this.selectionIds === value) {
        callback(new Error('上级模块不能选择本模块!'))
      } else {
        callback()
      }
    }
    var validateType = (rule, value, callback) => {
      if (value === 1 && this.form.code === '') {
        callback(new Error('模块编码不能为空!'))
      } else {
        callback()
      }
    }
    return {
      qx: '',
      colList: ['序', '功能模块', '类别', '编码', '图标', '链接/权限标识', '描述', '排序', '状态'],
      checkColList: [],
      tableLoading: false,
      currentPage: 1,
      pagesize: 4,
      tableTotal: 0,
      tableData: [],
      expandrowkeys: [],
      selectionIds: '',
      isAdd: true,
      dialogFormVisible: false,
      dialogTitle: '',
      form: {
        id: '',
        name: '',
        code: '',
        parentId: '',
        type: 1,
        desc: '',
        link: '',
        icon: 'homeFilled',
        queue: 0
      },
      rules: {
        name: [
          { required: true, message: '请输入模块名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        parentId: [
          { required: true, message: '请选择上级模块', trigger: 'blur' },
          { validator: validateParentId, trigger: 'blur' }
        ],
        type: [
          { validator: validateType, trigger: 'blur' }
        ]
      },
      iconData: [{
        value: 'homeFilled',
        label: '主页'
      }, {
        value: 'tools',
        label: '工具'
      }, {
        value: 'userFilled',
        label: '用户'
      }, {
        value: 'menu',
        label: '菜单'
      }, {
        value: 'Checked',
        label: '审核'
      }, {
        value: 'flag',
        label: '标记'
      }, {
        value: 'list',
        label: '列表'
      }, {
        value: 'comment',
        label: '注释'
      }, {
        value: 'briefcase',
        label: '皮包'
      }, {
        value: 'locationFilled',
        label: '位置'
      }, {
        value: 'platform',
        label: '平台'
      }, {
        value: 'infoFilled',
        label: '信息'
      }, {
        value: 'questionFilled',
        label: '问题'
      }, {
        value: 'share',
        label: '共享'
      }, {
        value: 'plus',
        label: '添加'
      }, {
        value: 'edit',
        label: '修改'
      }, {
        value: 'delete',
        label: '删除'
      }, {
        value: 'circleCheck',
        label: '启用'
      }, {
        value: 'circleClose',
        label: '禁用'
      }, {
        value: 'Setting',
        label: '设置'
      }, {
        value: 'warning',
        label: '警告'
      }, {
        value: 'search',
        label: '查询'
      }, {
        value: 'message',
        label: '消息'
      }, {
        value: 'guide',
        label: '指南'
      }, {
        value: 'link',
        label: '链接'
      }, {
        value: 'view',
        label: '查看'
      }, {
        value: 'picture',
        label: '图片'
      }, {
        value: 'pieChart',
        label: '图表'
      }
      ],
      // 上级模块数据
      menuData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    }
  },
  // 接收父组件传值
  props: ['clientHeight'],
  mounted () {
    this.qx = this.$route.params.qx
    this.getTableHeight()
    this.getData()
  },
  methods: {
    handleCurrentChange (val) {
      // this.currentRow = val
      if (val !== undefined) {
        this.selectionIds = val.id
      }
    },
    async getData () {
      this.tableLoading = true
      const { data: ret } = await this.$http.get(this.$api.modulelist)
      if (ret.status === 0) {
        this.tableData = ret.data
        // Table 目前的展开行，需要设置 row-key 属性
        this.tableData.forEach(node => {
          this.expandrowkeys.push(node.id)
        })
      }
      this.tableLoading = false
    },
    moduleTypeChange (val) {
      this.form.type = parseInt(val)
    },
    async getMenuData () {
      const { data: ret } = await this.$http.get(this.$api.moduledownmenu)
      if (ret.status === 0) {
        if (ret.data === null) {
          this.$message({
            message: ret.message,
            type: 'warning'
          })
          return
        }
        this.menuData = [ret.data]
      }
    },
    addInfo () {
      this.isAdd = true
      this.form.id = ''
      this.dialogTitle = '添加功能模块'
      this.dialogFormVisible = true
      this.getMenuData()
      // 添加时默认设置上级为0
      // setTimeout(() => {
      //   this.$refs.tree.setCurrentKey('0')
      // }, 1500)
    },
    async editInfo (id) {
      this.isAdd = false
      // if (this.selectionIds === '') {
      //   this.$message.error('请选择一条信息修改。')
      //   return
      // }
      this.dialogFormVisible = true
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.getMenuData()
      const { data: ret } = await this.$http.get(this.$api.moduleid + '/' + id)
      if (ret.status === 0) {
        const obj = ret.data
        Object.keys(this.form).forEach(key => {
          this.form[key] = obj[key]
        })
        // 修改时设置上级为pid
        // this.$nextTick(() => {
        //   this.$refs.tree.setCurrentKey(obj.parentId)
        // })
        // setTimeout(() => {
        //   this.$refs.tree.setCurrentKey(obj.parentId)
        // }, 1000)
        this.dialogTitle = '修改功能模块'
      } else {
        this.$message.error(ret.message)
      }
      loading.close()
    },
    saveInfo () {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          // console.log('form=', this.form)
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          const { data: ret } = await this.$http.post(this.$api.modulesave, this.form)
          if (ret.status === 0) {
            this.$message.success(ret.message)
            this.getData()
            this.closeForm()
          } else {
            this.$message.error(ret.message)
          }
          loading.close()
        } else {
          this.$message.error('验证没通过。')
          return false
        }
      })
    },
    delInfo () {
      if (this.selectionIds === '') {
        this.$message.error('请选择将删除的信息。')
        return
      }
      this.$confirm('此操作将删除已选择的信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        const { data: ret } = await this.$http.post(this.$api.moduledel + '?ids=' + this.selectionIds)
        if (ret.status === 0) {
          this.getData()
          this.$message.success(ret.message)
        } else {
          this.$message.error(ret.message)
        }
        loading.close()
      })
    },
    async enableInfo (bo) {
      const s = bo ? '启用' : '禁用'
      if (this.selectionIds === '') {
        this.$message.error('请选择将' + s + '的信息。')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const params = '?ids=' + this.selectionIds + '&bo=' + bo
      // console.log(params)
      const { data: ret } = await this.$http.post(this.$api.moduleenable + params)
      if (ret.status === 0) {
        this.getData()
        this.$message.success(ret.message)
      } else {
        this.$message.error(ret.message)
      }
      loading.close()
    },
    resetForm () {
      this.$refs.formRef.resetFields()
    },
    closeForm () {
      this.$refs.formRef.resetFields()
      this.dialogFormVisible = false
    },
    // 功能模块上级pid
    // handleNodeClick (data) {
    //   // console.log('NodeClick=', data)
    //   // console.log('data=', data.id)
    //   this.form.parentId = data.id
    // },
    getTableHeight () {
      this.tableHeight = this.clientHeight - 87
    }
  },
  watch: {
    clientHeight: function (val) {
      this.getTableHeight()
    }
  }
}
</script>

<style>

</style>
